import Hero from '../components/Hero';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../context/GlobalContext';
import Banner from '../components/Banner';

const SingleLesson = (searchedType) => {
  const { lessons } = useGlobalContext();

  const lesson = lessons.find((lesson) => lesson.type === searchedType);

  if (!lesson) {
    return (
      <div>
        <h3>No such lesson type found</h3>
        <Link to='/lessen'>Back to 'lessen'</Link>
      </div>
    );
  }

  const { type } = lesson;

  return (
    <Hero hero='lessonsHero'>
      <Banner title={`${type} les`}>
        <Link to='/lessen'> back to lessen</Link>
      </Banner>
    </Hero>
  );
};

export default SingleLesson;
